import useClientState from "./useClientState";

export default feature => () => useClientState(`state.${feature}`, {});
